// Shared flag to suppress automatic session-expired redirects during bulk exports.
// Set to true before starting a bulk operation and reset in finally.
export const exportState = {
  suppressRedirect: false,
};
